/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Conversation } from '../../models/conversation';
import { CreateConversationRequest } from '../../models/create-conversation-request';

export interface CreateConversation$Params {
      body: CreateConversationRequest
}

export function createConversation(http: HttpClient, rootUrl: string, params: CreateConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<Conversation>> {
  const rb = new RequestBuilder(rootUrl, createConversation.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Conversation>;
    })
  );
}

createConversation.PATH = '/v0/conversations';
